import React, {useMemo} from 'react';
import { Navigate } from 'react-router-dom';
import {useSelector} from 'react-redux';
import {RootState} from '../../shared/state/root-reducer';
import {subNavItemsToIgnore} from '../../shared/constants/sub-nav-constants';

function HomeView() {

    const userContext = useSelector((state: RootState) => state.userContext);


    const route = useMemo(()=>{

        /**
         * User profile landing page route takes precedent
         * but need to make sure the portal supports that route.
         * If it doesn't, choose the first route in SubNav that is supported by the portal
         * */

        const profile = userContext.userProfile;

        let subNavObj;

        const landingPath =
            profile?.landingPageRoute?.trim().startsWith('/')
                ? profile.landingPageRoute.trim()
                : '';

        if(landingPath){
            subNavObj = profile.SubNav.find((nav) => {
                return nav.route.trim() === landingPath
            })
        }

        if(!subNavObj || subNavItemsToIgnore.includes(subNavObj.displayValue)){
            //Either landing path doesn't exist or is not supported by the portal
            //Choose default route set in loginUserGetProfile
            return profile.defaultRoute
        }else{
            return subNavObj?.route
        }

    }, [userContext])

    return <Navigate to={route ? route : '/patient/dashboard/active'} replace />

}

export default HomeView;